<div class="back-button-container">
  <i class="oda-chevron-left" [style.color]="color" [style.font-size]="fontSize" (click)="backWithLocation()"></i>
</div>
